class Carriage {
  constructor() {
    this.type = ''
    this.count = 1
  }
}

export { Carriage }
